<!-- Same element shape as the store-offer footer: a padding-less full-width
     flex action row — the shared width calcs are calibrated for this box. -->
<div class="col-lg-12 footer px-0 pt-1 pb-2 action-row">
  <app-button
    variant="primary"
    [disabled]="saveDisabled ? 'disabled' : null"
    startIcon="fa-save mr-1"
    [dataTestid]="saveTestId"
    (click)="save.emit()"
  >
    {{ saveLabel | translate }}
  </app-button>

  <!-- Screen-specific secondary actions (e.g. Save & Continue) -->
  <ng-content select="[extra-actions]"></ng-content>

  <a *ngIf="showCancel" class="actionLink" (click)="cancelClick.emit()">{{
    cancelLabel | translate
  }}</a>

  <app-button
    *ngIf="showDelete"
    class="ml-auto"
    variant="danger"
    startIcon="fa-trash mr-1 text-white"
    [dataTestid]="deleteTestId"
    [disabled]="deleteDisabled ? 'disabled' : null"
    (click)="deleteClick.emit()"
  >
    {{ deleteLabel | translate }}
  </app-button>
</div>
